import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdCopyAll, MdDelete, MdModeEdit } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button, Form, Modal, Spinner, Table } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";



const Processo = props => {

    const [lesson_cards, SetLessonCards] = useState(null);
    const [loading_screen, setLoadingScreen] = useState(true);
    const [loading_processos, setLoadingProcessos] = useState(false);
    const [search_oficial, setSearchOficial] = useState('');

    const [processos, setProcessos] = useState([]);
    const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



    const [search, setSearch] = useState('');
    const { faculdade_id, faculdade_name } = props;
    const [show_warning, setShowWarning] = useState(false);
    const [processo_id, setProcessoId] = useState(null);


    const [questaoSelect, setQuestaoSelect] = useState({});

    const [showModal, setShowModal] = useState(false);
    const [showDuplicateModal, setShowDuplicateModal] = useState(false);
    const [loadingDuplicate, setLoadingDuplicate] = useState(false);
    const [loadingDuplicateJobs, setLoadingDuplicateJobs] = useState(false);
    const [loadingDuplicateSources, setLoadingDuplicateSources] = useState(false);
    const [duplicateJobs, setDuplicateJobs] = useState([]);
    const [duplicateSources, setDuplicateSources] = useState([]);
    const [duplicateForm, setDuplicateForm] = useState({
        init_subscribe: '',
        end_subscribe: '',
        inicio_processo: '',
        fim_processo: '',
        process_ids: [],
    });
    const [duplicateMessage, setDuplicateMessage] = useState('');
    const [duplicateError, setDuplicateError] = useState('');
    let refs = [];
    const dispatch = useDispatch();

    const user = useSelector(state=>state.AppReducer.user);

    const GetProcessos = async (page, search) => {

        let response = await Request.Get(`faculdade/get_processos/${faculdade_id}?page=${page}&search=${search}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        if (response.pagination.current_page == page) {

            setProcessos(response.processos);

            setPagination(response.pagination);
            setLoadingScreen(false);
            setLoadingProcessos(false);


        }
    }

    const DeleteProcesso = async (processo_id) => {

        let response = await Request.Delete(`faculdade/delete_processo/${processo_id}`);
        console.log(response);
        if (response === undefined) return;

        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        GetProcessos(pagination.current_page, search_oficial);



    }

    useEffect(() => {
        GetProcessos(1, search_oficial);
    }, []);

    const formatJobDate = (value) => {
        if (value == null) return '-';
        return moment(value).format('DD/MM/YYYY HH:mm');
    }

    const normalizeErrors = (errors) => {
        if (errors == null) return 'Não foi possível executar a ação.';
        if (typeof errors === 'string') return errors;

        return Object.values(errors).flat().join('\n');
    }

    const buildDefaultDuplicateForm = () => {
        return {
            init_subscribe: '',
            end_subscribe: '',
            inicio_processo: '',
            fim_processo: '',
            process_ids: [],
        };
    }

    const GetDuplicateSources = async () => {
        setLoadingDuplicateSources(true);

        let response = await Request.Get(`faculdade/duplicate_processes_sources/${faculdade_id}`);

        if (response === undefined) {
            setLoadingDuplicateSources(false);
            return;
        }

        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }

        if (response.errors != null || response.error != null) {
            setDuplicateError(normalizeErrors(response.errors || response.error));
        } else {
            const sources = response.processos || [];
            setDuplicateSources(sources);
            setDuplicateForm((prev) => ({
                ...prev,
                process_ids: sources.map((processo) => processo.id),
            }));
        }

        setLoadingDuplicateSources(false);
    }

    const GetDuplicateJobs = async () => {
        setLoadingDuplicateJobs(true);

        let response = await Request.Get(`faculdade/duplicate_processes_jobs/${faculdade_id}`);

        if (response === undefined) {
            setLoadingDuplicateJobs(false);
            return;
        }

        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }

        if (response.errors != null || response.error != null) {
            setDuplicateError(normalizeErrors(response.errors || response.error));
        } else {
            setDuplicateJobs(response.jobs || []);
        }

        setLoadingDuplicateJobs(false);
    }

    const OpenDuplicateModal = () => {
        setDuplicateForm(buildDefaultDuplicateForm());
        setDuplicateMessage('');
        setDuplicateError('');
        setShowDuplicateModal(true);
        GetDuplicateSources();
        GetDuplicateJobs();
    }

    const ToggleDuplicateSource = (processoId) => {
        setDuplicateForm((prev) => {
            const selected = prev.process_ids || [];
            const exists = selected.includes(processoId);

            return {
                ...prev,
                process_ids: exists
                    ? selected.filter((id) => id !== processoId)
                    : [...selected, processoId],
            };
        });
    }

    const SelectAllDuplicateSources = () => {
        setDuplicateForm((prev) => ({
            ...prev,
            process_ids: duplicateSources.map((processo) => processo.id),
        }));
    }

    const ClearDuplicateSources = () => {
        setDuplicateForm((prev) => ({
            ...prev,
            process_ids: [],
        }));
    }

    const SubmitDuplicateProcess = async () => {
        if ((duplicateForm.process_ids || []).length === 0) {
            setDuplicateError('Selecione ao menos um agendamento base para duplicar.');
            return;
        }

        setLoadingDuplicate(true);
        setDuplicateMessage('');
        setDuplicateError('');

        let response = await Request.Post(
            `faculdade/duplicate_processes/${faculdade_id}`,
            JSON.stringify(duplicateForm),
            { 'Content-Type': 'application/json' }
        );

        setLoadingDuplicate(false);

        if (response === undefined) return;

        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }

        if (response.errors != null || response.error != null) {
            setDuplicateError(normalizeErrors(response.errors || response.error));
            return;
        }

        setDuplicateMessage(response.message || 'Duplicação colocada na fila.');
        GetDuplicateJobs();
    }

    const duplicateJobsHasRunning = duplicateJobs.some((job) => (
        job.status === 'Na fila de execução' || job.status === 'Executando'
    ));

    useEffect(() => {
        if (!showDuplicateModal) return;

        const interval = setInterval(() => {
            GetDuplicateJobs();
        }, 5000);

        return () => clearInterval(interval);
    }, [showDuplicateModal]);

    let pesquisarTimeout = null;
    const history = useHistory();
    return (
        <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div>
                    <p className="text-muted">Aqui ficam {(user.empresa==null || user.empresa.change_text==false)?'os processos da instituição':'as vagas/cargos do processo'} "{faculdade_name}"</p>

                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}

                    <div className="flex jcsb flex-wrap mb-4">

                        <Search placeholder={"Pesquisar pelo nome "+((user.empresa==null || user.empresa.change_text==false)?'do processo':'da vaga/cargo')} ValueChange={value => {
                            clearTimeout(pesquisarTimeout);
                            setSearchOficial(value);

                            pesquisarTimeout = setTimeout(() => {
                                let page = { ...pagination };
                                page.current_page = 1;
                                setPagination(pagination);
                                setLoadingProcessos(true);

                                GetProcessos(1, value)

                            }, 500);
                        }} />


                        <div className="flex align-center flex-wrap" style={{ gap: 8 }}>
                            {<>
                                <Button variant="outline-primary" className="flex align-center jcc" onClick={OpenDuplicateModal}>
                                    <MdCopyAll style={{ marginRight: 10 }} />
                                    <p style={{ margin: 0 }}>Duplicar agendamentos</p>
                                </Button>
                                <Link to={{
                                    pathname: "/processos/register/" + faculdade_id,
                                    // state: {
                                    //     course_id: id
                                    // }
                                }} style={{ textDecoration: "none" }}>
                                    <Button variant="success" className="flex align-center jcc"><FaListAlt style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Adicionar {(user.empresa==null || user.empresa.change_text==false)?'processo':'vaga/cargo'}</p></Button>
                                </Link>
                            </>}
                        </div>
                    </div>

                    <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>Nome</th>
                                        <th>Data de início</th>
                                        <th>Data de encerramento</th>

                                        <th data-priority="3">Ações</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_processos == false && processos.map((item, id) => (

                                        <tr key={id}>
                                            <td>{item.name}</td>
                                            <td>{moment(item.inicio).format('DD/MM/YYYY HH:mm')}</td>
                                            <td>{moment(item.fim).format('DD/MM/YYYY HH:mm')}</td>
                                            {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                            <td>
                                                <Link to={`/processos/show/${item.id}`} onClick={(e) => e.stopPropagation()}>

                                                    <span
                                                        onClick={() => {

                                                        }}
                                                        className="inline-flex align-center jcc bg-warning icon"
                                                        style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                        title="Gerenciar processo"
                                                    >
                                                        <BsFillEyeFill size={17} color="white" />
                                                    </span>
                                                </Link>
                                                {(user.role=='region_admin' || (user.empresa==null || user.empresa.can_edit)) && <Link to={`/processos/edit/${item.id}`} onClick={(e) => e.stopPropagation()}>
                                                    <span
                                                        className="inline-flex align-center jcc bg-info icon"
                                                        style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px", marginLeft: "2px" }}
                                                        data-toggle="tooltip"
                                                        title="Editar questão"
                                                    >
                                                        <MdModeEdit color="white" size={17} />
                                                    </span>
                                                </Link>}
                                                {user.role!='coordenador' &&  user.role != "viwer" && (user.role=='region_admin' || (user.empresa==null || user.empresa.can_exclude)) && <span
                                                    onClick={(e) => {
                                                        setProcessoId(item.id);
                                                        setShowWarning(true);
                                                        e.stopPropagation();
                                                    }}
                                                    className="inline-flex align-center jcc bg-danger icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Deletar processo"
                                                >
                                                    <MdDelete size={17} color="white" />
                                                </span>}
                                            </td>

                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            {loading_processos == true &&
                                <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                                    </div> */}
                                    <CircularProgress />
                                </div></div>

                            }
                        </div>
                    </div>
                    {loading_processos == false && processos.length == 0 && <div className="row w-100">
                        <div className="col-12">
                            <p style={{ textAlign: 'center' }}>Nenhum processo encontrado</p>

                        </div>
                    </div>}

                    <Pagination
                        className={(pagination.last_page == 1 ? "hide" : "")}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                        count={pagination.last_page}
                        value={pagination.current_page}
                        onChange={(_, value) => {
                            setLoadingProcessos(true);
                            console.log(_, value);
                            let page = { ...pagination };
                            page.current_page = value;
                            setPagination(pagination);
                            GetProcessos(value, search_oficial)
                        }}
                    />

                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_processo={this.get_processo.bind(this)} {...this.props} />} */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
                    warning
                    title={"Atenção"}
                    onConfirm={() => {
                        setShowWarning(false);
                        setLoadingProcessos(true);
                        DeleteProcesso(processo_id);
                        // this.delete_banner(this.state.banner_to_delete);
                    }}
                    onCancel={() => {
                        setShowWarning(false);
                    }}
                    show={show_warning}
                    confirmBtnText='Sim, desejo apagar'
                    cancelBtnText='Cancelar'
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}
                >
                    Ao deletar este processo, ele não estará mais disponível no sistema
                </SweetAlert>

                <Modal
                    show={showDuplicateModal}
                    onHide={() => setShowDuplicateModal(false)}
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Duplicar agendamentos</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="text-muted">
                            Selecione quais agendamentos base serão copiados. As horas das provas serão mantidas de cada agendamento original.
                        </p>

                        {duplicateError !== '' && <div className="alert alert-danger" style={{ whiteSpace: 'pre-line' }}>{duplicateError}</div>}
                        {duplicateMessage !== '' && <div className="alert alert-success">{duplicateMessage}</div>}

                        <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <Form.Label className="mb-0">Agendamentos base</Form.Label>
                                <div>
                                    <Button variant="outline-secondary" size="sm" className="mr-2" onClick={SelectAllDuplicateSources} disabled={loadingDuplicateSources || duplicateSources.length === 0}>
                                        Todos
                                    </Button>
                                    <Button variant="outline-secondary" size="sm" onClick={ClearDuplicateSources} disabled={loadingDuplicateSources}>
                                        Limpar
                                    </Button>
                                </div>
                            </div>

                            {loadingDuplicateSources && (
                                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                    <Spinner animation="border" size="sm" />
                                    <span>Carregando agendamentos base...</span>
                                </div>
                            )}

                            {!loadingDuplicateSources && duplicateSources.length > 0 && (
                                <div className="border rounded p-2" style={{ maxHeight: 180, overflowY: 'auto' }}>
                                    {duplicateSources.map((processo) => (
                                        <Form.Check
                                            key={processo.id}
                                            id={`duplicate-source-${processo.id}`}
                                            type="checkbox"
                                            label={processo.name}
                                            checked={(duplicateForm.process_ids || []).includes(processo.id)}
                                            onChange={() => ToggleDuplicateSource(processo.id)}
                                        />
                                    ))}
                                </div>
                            )}

                            {!loadingDuplicateSources && duplicateSources.length === 0 && (
                                <div className="alert alert-warning mb-0">
                                    Nenhum agendamento base encontrado.
                                </div>
                            )}
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group>
                                    <Form.Label>Início da inscrição</Form.Label>
                                    <Form.Control
                                        type="datetime-local"
                                        value={duplicateForm.init_subscribe}
                                        onChange={(e) => setDuplicateForm({ ...duplicateForm, init_subscribe: e.target.value })}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group>
                                    <Form.Label>Fim da inscrição</Form.Label>
                                    <Form.Control
                                        type="datetime-local"
                                        value={duplicateForm.end_subscribe}
                                        onChange={(e) => setDuplicateForm({ ...duplicateForm, end_subscribe: e.target.value })}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group>
                                    <Form.Label>Data de início da prova</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={duplicateForm.inicio_processo}
                                        onChange={(e) => setDuplicateForm({ ...duplicateForm, inicio_processo: e.target.value })}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group>
                                    <Form.Label>Data de encerramento da prova</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={duplicateForm.fim_processo}
                                        onChange={(e) => setDuplicateForm({ ...duplicateForm, fim_processo: e.target.value })}
                                    />
                                </Form.Group>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
                            <h6 className="mb-0">Acompanhamento</h6>
                            <Button variant="outline-secondary" size="sm" onClick={GetDuplicateJobs} disabled={loadingDuplicateJobs}>
                                {loadingDuplicateJobs ? <Spinner animation="border" size="sm" /> : 'Atualizar'}
                            </Button>
                        </div>

                        <div className="table-responsive">
                            <Table striped bordered hover size="sm">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Status</th>
                                        <th>Progresso</th>
                                        <th>Criado em</th>
                                        <th>Erro</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {duplicateJobs.map((job) => (
                                        <tr key={job.id}>
                                            <td>{job.id}</td>
                                            <td>{job.status}</td>
                                            <td>{job.progresso || 0}/{job.total_progresso || 0}</td>
                                            <td>{formatJobDate(job.created_at)}</td>
                                            <td>{job.error_friendly || job.error_message || '-'}</td>
                                        </tr>
                                    ))}
                                    {duplicateJobs.length === 0 && (
                                        <tr>
                                            <td colSpan="5" className="text-center">Nenhuma geração encontrada</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowDuplicateModal(false)}>
                            Fechar
                        </Button>
                        <Button variant="primary" onClick={SubmitDuplicateProcess} disabled={loadingDuplicate || duplicateJobsHasRunning}>
                            {loadingDuplicate ? <Spinner animation="border" size="sm" /> : 'Gerar novos agendamentos'}
                        </Button>
                    </Modal.Footer>
                </Modal>


            </div>

        </div>
    )
}

export default Processo;
